import styled, { css } from 'styled-components/macro'
import { transparentize } from 'polished'

export const Text = styled.p<{ type?: string; size?: string; align?: string }>`
  margin: 0;
  padding: 0;
  font-weight: ${(props) => props.theme.font.weight.regular};
  font-size: 1.6rem;
  line-height: 1.12;
  text-align: ${(props) => (props.align ? props.align : 'center')};
  word-break: break-word;
  color: ${(props) => props.theme.color.text};
  &::first-letter {
    text-transform: capitalize;
  }
  ${(props) =>
    props.type === 'error' &&
    css`
      color: ${(props) => props.theme.color.danger};
    `}
  ${(props) =>
    props.type === 'support' &&
    css`
      color: ${(props) => transparentize(0.5, props.theme.color.text)};
    `}
  ${(props) =>
    props.size === 'small' &&
    css`
      font-size: 1.4rem;
      line-height: 1.12;
    `}
`

export const Description = styled.span`
  margin: 0;
  padding: 0;
  font-weight: ${(props) => props.theme.font.weight.regular};
  font-size: 1.4rem;
  line-height: 1.12;
  word-break: break-word;
  color: ${(props) => props.theme.color.textSecondary};
`
